module.exports = __webpack_public_path__ + "static/img/logo-ADELAIDE.b71e5bf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-ADELAIDE.svg
// module id = 5Af8
// module chunks = 1